export default import.meta.ROLLUP_FILE_URL_Df9kOOs1;